import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
} from "common/components/ui/Drawer";
import { useAuth } from "common/context/AuthContext";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface LogOutModalProps {
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
}

export default function LogOutModal({ isOpen, setIsOpen }: LogOutModalProps) {
  const isDesktop = useTwBreakpoint("lg");
  const { logout } = useAuth();

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Close = isDesktop ? DialogClose : DrawerClose;
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen}>
      <Content>
        <Header
          title="Are you sure you want to log out?"
          subtitle="You will be returned to the login screen"
        />

        <Footer className="justify-end">
          <Close asChild>
            <Button variant="secondary-black">Cancel</Button>
          </Close>

          <Button onClick={logout} data-cy="log-out-confirmation-button">
            Log out
          </Button>
        </Footer>
      </Content>
    </Component>
  );
}
